(function () {

	"use strict";

    angular
        .module("vertica.util", [])
        .directive("focus",
            function($timeout) {
                return {
                    scope: {
                        trigger: '@focus'
                    },
                    link: function(scope, element) {

                        scope.$watch('trigger',
                            function(value) {
                                if (value === "true") {
                                    $timeout(function() {
                                        element[0].focus();
                                    });
                                }
                            });
                    }
                };
            });

	angular
        .module("vertica.util")
        .factory("util", util);

	util.$inject = [];

	/**
     * Use as the maximum length of an array-like value.
     * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
     * for more details.
     */

	var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;

	function util () {

		return {
			includes: includes,
			isEmpty: isEmpty,
			convertDateYMD: convertDateYMD
		};


		/**
		 * Gets the index at which the first occurrence of `NaN` is found in `array`. If `fromRight` is provided elements of `array` are iterated from right to left.
		 *
		 * @link https://github.com/lodash/lodash/blob/3.5.0/lodash.src.js#L505
		 *
		 * @ngdoc function
		 * @name indexOfNaN
		 *
		 * @param {Array} array - Array to run search on.
		 * @param {Number} fromIndex - The index to search from.
		 * @param {Boolean} [fromRight] - Specify iterating from right to left.
		 *
		 * @returns {Number} Returns the index of the matched `NaN`, else `-1`.
		 */

		function indexOfNaN (array, fromIndex, fromRight) {
			var other;
			var index = fromIndex + (fromRight ? 0 : -1);
			var length = array.length;
			while ((fromRight ? index-- : ++index < length)) {
				other = array[index];
				if (other !== other) return index;
			}
			return -1;
		}


		/**
		 * Base implementation of `.indexOf` on arrays.
		 *
		 * @link https://github.com/lodash/lodash/blob/3.5.0/lodash.src.js#L320
		 *
		 * @ngdoc function
		 * @name baseIndexOf
		 *
		 * @param {Array} array - Array to run search on.
		 * @param {*} value - Value to search for.
		 * @param {Number} fromIndex - Index to search from.
		 *
		 * @returns {Number} Returns the index of the matched value, else `-1`.
		 */

		function baseIndexOf (array, value, fromIndex) {
			if (value !== value) return indexOfNaN(array, fromIndex);
			var index = fromIndex - 1;
			var length = array.length;
			while (++index < length) {
				if (array[index] === value) return index;
			}
			return -1;
		}


		/**
		 * Checks if `value` is in `collection` using `SameValueZero` for equality comparisons. `SameValueZero` comparisons are like strict equality comparisons,
		 * e.g. `===`, except that `NaN` matches `NaN`. See the
		 * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
		 * for more details.
		 *
		 * @ngdoc method
		 * @name includes
		 *
		 * @param {(Array|Object|String)} collection - The collection to run the search on.
		 * @param {*} target - The value to search for.
		 *
		 * @returns {Boolean} Returns `true` if a matching element is found, else `false`.
		 *
		 * @example
		 *
		 * util.includes([1, 2, 3], 1);
		 * // => true
		 *
		 * util.includes({ 'user': 'fred', 'age': 40 }, 'fred');
		 * // => true
		 *
		 * util.includes('pebbles', 'eb');
		 * // => true
		 */

		function includes (collection, target) {
			var length = collection ? collection.length : 0;
			if (!isLength(length)) {
				collection = values(collection);
				length = collection.length;
			}
			if (!length) return false;
			return (typeof collection == "string" || !angular.isArray(collection) && isString(collection))
				? (collection.indexOf(target) > -1)
				: (baseIndexOf(collection, target, 0) > -1);
		}

		function convertDateYMD(date){
            var mm = date.getMonth() + 1; // getMonth() is zero-based
            var dd = date.getDate();

            return [date.getFullYear(), (mm>9 ? '' : '0') + mm, (dd>9 ? '' : '0') + dd].join('-');
        }


		/**
		 * Check whether an object is empty or not.
		 * Note the this method only checks enumerable properties (using `.hasOwnProperty()`).
		 *
		 * @link http://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
		 *
		 * @private
		 *
 		 * @param {Object} obj - Object to run the check on.
		 * @returns {Boolean} Whether the object is empty or not.
		 */

		function isEmpty (obj) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) return false;
			}
			return true;
		}


		/**
		 * Checks if a value is a valid array-like length.
		 * This function is based on ES `ToLength`. See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
		 * for more details.
		 *
		 * @ngdoc function
		 * @name isLength
		 *
		 * @param {*} value - The value to check.
		 *
		 * @returns {Boolean} Returns `true` if `value` is a valid length, else `false`.
		 */

		function isLength (value) {
			return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}


		/**
		 * Checks if `value` is object-like.
		 *
		 * @ngdoc function
		 * @name isObjectLike
		 *
		 * @param {*} value - The value to check.
		 *
		 * @returns {Boolean} Returns `true` if `value` is object-like, else `false`.
		 */

		function isObjectLike (value) {
			return (value && typeof value == "object") || false;
		}


		/**
		 * Checks if `value` is classified as a `String` primitive or object.
		 *
		 * @ngdoc function
		 * @name isString
		 *
		 * @param {*} value - The value to check.
		 *
		 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
		 */

		function isString (value) {
			return typeof value == "string" || (isObjectLike(value) && Object.prototype.toString.call(value) == "[object String]") || false;
		}

		
	}

})();